/*
 * @Description:
 * @Date: 2021-10-20 11:43:02
 */
export const route = [
  {
    path: '/product-mgmt/library',
    name: 'product-mgmt-library',
    meta: {
      title: '产品库管理'
    },
    component: () => import('../views/product-mgmt-library.vue')
  }
];
